import React from 'react'
import { Form, Input, InputProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { Dimension } from '../../../../../features/dimension/types/Dimension'
import ParentDimensionField from './ParentDimensionField'
import DefaultToggleField from './DefaultToggleField'

export interface DimensionFormValues {
  name: string
  parentDimensionId?: string
  default?: boolean
}

interface DimensionFormFieldsProps {
  flatList: Dimension[]
  excludeIds?: string[]
  disabled?: boolean
  isSettingDefault?: boolean
  nameInputProps?: InputProps
}

const DimensionFormFields: React.FC<DimensionFormFieldsProps> = ({
  flatList,
  excludeIds,
  disabled,
  isSettingDefault,
  nameInputProps
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Form.Item name="name" label={t('global:name')} rules={[{ required: true, message: t('global:required-field') }]}>
        <Input placeholder={t('global:name')} {...nameInputProps} />
      </Form.Item>
      <Form.Item name="parentDimensionId" label={t('dimensionsPage:inspectorParent')}>
        <ParentDimensionField flatList={flatList} excludeIds={excludeIds} disabled={disabled} />
      </Form.Item>
      <Form.Item name="default" label={t('dimensionsPage:inspectorDefault')}>
        <DefaultToggleField disabled={disabled} loading={isSettingDefault} />
      </Form.Item>
    </>
  )
}

export default DimensionFormFields
